import { render, staticRenderFns } from "./ExplanationTitle.vue?vue&type=template&id=60926de2&scoped=true"
import script from "./ExplanationTitle.vue?vue&type=script&lang=js"
export * from "./ExplanationTitle.vue?vue&type=script&lang=js"
import style0 from "./ExplanationTitle.vue?vue&type=style&index=0&id=60926de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60926de2",
  null
  
)

export default component.exports